<template>
	<section id="prebuild-reviews" class="prebuild-reviews">
		<div class="container">
			<img
				src="/images/prebuild-series/reviews-section-icon.svg"
				class="prebuild-reviews__heading-icon"
			>
			<h3 class="prebuild-reviews__heading">
				Reviews for {{ prebuildName }} ({{ reviewCounter }})
			</h3>

			<div v-if="reviewCounter" class="prebuild-reviews__list">
				<div v-for="review in prebuildReviews" :key="review.id">
					<prebuild-review :review="review" />
				</div>
				<mugen-scroll
					:handler="onInfiniteHandler"
					:should-handle="shouldHandle"
				>
					<template v-if="isLastPage">
						<img
							class="spinner"
							src="/assets/spinner-black.svg"
							title="Loading reviews..."
						>
					</template>
				</mugen-scroll>
			</div>
			<div v-else class="prebuild-reviews__no-reviews">
				<p>There are no reviews for this PC yet.</p>
			</div>
		</div>
	</section>
</template>

<script>
import PrebuildReview from "./prebuild-review";
import MugenScroll from "vue-mugen-scroll";

export default {
	name: "PrebuildReviews",
	components: {
		PrebuildReview,
		MugenScroll
	},
	props: {
		currentPrebuild: {
			type: Object,
			default() {
				return {};
			}
		},
		reviews: {
			type: Object,
			default() {
				return {};
			}
		},
		infiniteScrollHandler: {
			type: Function,
			default() {
				return () => {};
			}
		}
	},
	data() {
		return {
			isInfiniteReady: true
		};
	},
	computed: {
		prebuildName() {
			return this.currentPrebuild.name || "";
		},
		prebuildReviews() {
			return this.reviews.data || [];
		},
		reviewCounter() {
			return this.reviews.total_items || 0;
		},
		page() {
			return this.reviews.page;
		},
		isLastPage() {
			return this.reviews.total_pages != this.page;
		},
		hasRemainingReviews() {
			return this.reviews.total_pages >= this.page + 1;
		},
		shouldHandle() {
			return !this.hasRemainingReviews || !this.isInfiniteReady ? false : true;
		}
	},
	methods: {
		async onInfiniteHandler() {
			this.isInfiniteReady = false;

			const newPage = this.page + 1;
			await this.infiniteScrollHandler(newPage);

			this.isInfiniteReady = true;
		}
	}
};
</script>

<style lang="scss" scoped>
.prebuild-reviews {
	background: #fff;
	padding: 65px 0 30px;

	&__heading-icon {
		width: 50px;
		margin-bottom: 20px;

		@media (min-width: 580px) and (max-width: 991px) {
			display: block;
			margin: 0 auto 20px;
		}
	}

	&__heading {
		color: #444259;
		font-size: 32px;
		font-weight: bold;
		letter-spacing: 0;
		line-height: 38px;
		margin: 0 0 25px;

		@media (min-width: 580px) and (max-width: 991px) {
			text-align: center;
		}
	}

	&__list {
		max-width: 720px;
	}

	&__no-reviews {
		padding: 60px 0;

		p {
			font-style: italic;
			font-size: 18px;
			color: #5f707f;
		}
	}

	.spinner {
		width: 10%;
		display: block;
		margin: 0 auto;
	}
}
</style>
